module.exports = __webpack_public_path__ + "img/52.c03dba21.jpg";